import { GeoJSON } from 'ol/format'
/**
 * @module
 * @api
 */

/**
 * Applications API
 * @constructor
 */
export default function Applications(applicationsInstance) {
  this.applicationsInstance = applicationsInstance
}

/**
 * Start application by ID
 * @param {string} id Application id
 * @memberof! module:api/Applications#
 * @return {Promise} promise Resolves when the application is ready to accept user input
 * @api
 */
Applications.prototype.startById = function(applicationId) {
  return this.applicationsInstance.startApplicationById(applicationId)
}

/**
 * Stop active applicaton
 * @memberof! module:api/Applications#
 * @return {Promise} promise Resolves when the application is stopped
 * @api
 */
Applications.prototype.stop = function() {
    return this.applicationsInstance.stopApplication()
}

/**
 * Enable applications
 * @memberof! module:api/Applications#
 * @api
 */
Applications.prototype.enable = function() {
    return this.applicationsInstance.enable()
}

/**
 * Disable applications
 * @memberof! module:api/Applications#
 * @return {Promise} promise Resolves when the applications is disabled
 * @api
 */
Applications.prototype.disable = function() {
    return this.applicationsInstance.disable()
}
/**
 * Add event listener
 * @param {string} type event type
 * @return {function} listener callback function
 * @memberof! module:api/Applications#
 * @api
 */
Applications.prototype.on = function(type, callback) {
    this.applicationsInstance.on(type, callback)
}
/**
 * Remove event listener
 * @param {string} type event type
 * @return {function} listener callback function
 * @memberof! module:api/Applications#
 * @api
 */
Applications.prototype.un = function(type, callback) {
    this.applicationsInstance.un(type, callback)
}
